import React from 'react';
import {Container} from 'reactstrap';
import RenderIf from '@src/components/RenderIf/RenderIf';
import Translate from '@src/components/Translate/Translate';
import ErrorRetryControls from './ErrorRetryControls';
import {ErrorRepresentationProps} from '@src/@types/components/ErrorRepresentation';
import classnames from '@src/helpers/classnames';
import AbstractPrintableHttpException from '@src/exceptions/AbstractPrintableHttpException';
import NotificationException from '@src/exceptions/NotificationException';

export default function ErrorRepresentation(props: ErrorRepresentationProps) {
    const {
        error,
        outsideContainer,
        retryButtonLabel,
        retryOnClick = () => {// eslint-disable-line
        },
        retryInProcess = false,
        retryAttempts,
        retryLastAttemptAt,
        nextTryInSecondsText,
        nextTrySoonText,
        nextTryNowText,
        triedAttemptsText,
        color,
        className,
        withoutErrorName = false,
        withoutStackTrace = false,
        size,
        ...rest
    } = props;

    const isNotification = error instanceof NotificationException;

    const representation = <div className={classnames('alert', className, {
        [`alert-${color ?? (isNotification ? 'info' : 'danger')}`]: true,
        'px-2 py-1': size === 'sm',
        'mb-0': !className,
    })} {...rest}>
        {error instanceof AbstractPrintableHttpException ? (
                <>
                    {withoutErrorName ? null : <Translate message={error.getRepresentationTitle()} tag="h3"/>}
                    <RenderIf
                            expression={error.getHtmlResponse()}
                            render={rawHtml => {
                                return <div className="mt-2" dangerouslySetInnerHTML={{
                                    __html: rawHtml
                                }}/>;
                            }}
                            renderElse={() => {
                                const ErrorMessageComponent = error.getMessageComponent();
                                if (ErrorMessageComponent) {
                                    return <ErrorMessageComponent error={error}/>;
                                }

                                return null;
                            }}
                    />

                </>
        ) : (
                isNotification ? (
                        <Translate message={error.message} tag="div"/>
                ) : (
                        <>
                            {withoutErrorName ? null : <Translate message={error.name} tag="h3"/>}
                            <Translate message={error.message} tag="div"/>
                        </>
                )

        )}

        <RenderIf expression={!withoutStackTrace && error.stack}>
            <pre className="mt-2">{error.stack}</pre>
        </RenderIf>

        <ErrorRetryControls {...{
            retryButtonLabel,
            retryOnClick,
            retryInProcess,
            retryAttempts,
            retryLastAttemptAt,
            nextTryInSecondsText,
            nextTrySoonText,
            nextTryNowText,
            triedAttemptsText,
        }}/>
    </div>;

    if (outsideContainer) {
        return representation;
    }

    return <Container className="py-5">{representation}</Container>;
}
